export function get(url) {
  return fetch(url).then((response) => {
    if (!response.ok) {
      return Promise.reject(response);
    }

    return response.text();
  });
}

export function post(url, data) {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    body: JSON.stringify(data),
  }).then((response) => {
    if (!response.ok) {
      return Promise.reject(response);
    }

    return response.text();
  });
}
